import React from 'react';
import { PersonType, PersonModel, DefaultPersonDetails } from '../../types';
import { FieldValue, AddressValue } from './';
import { DefaultTrustedContactDetails, TrustedContactModel } from '@tradingblock/types';

const Person: React.FC<{ value: PersonModel | TrustedContactModel | null | undefined; personType: PersonType }> = ({
  value,
  personType,
  children,
}) => {
  const person = value || (personType === PersonType.TrustedContact && DefaultTrustedContactDetails) || DefaultPersonDetails;
  const suffix = personType !== PersonType.TrustedContact && (person as PersonModel).suffix 
    ? ((person as PersonModel).suffix.trim() !== '' && (person as PersonModel).suffix.trim() !== 'None' ? (person as PersonModel).suffix.trim() : '')
    : '';
  return (
    <FieldValue value={!!person.firstName && !!person.lastName}>
      <FieldValue
        value={`${person.firstName || ''} ${(personType !== PersonType.TrustedContact && ((person as PersonModel).middleName || '')) || ''} ${person.lastName || ''} ${suffix ? ` ${suffix}` : ''}`}
      />
      <br />

      {personType === PersonType.AccountHolder && <FieldValue value={person.email}>{person.email}</FieldValue>}

      {personType !== PersonType.AccountHolder && <AddressValue value={person.address} />}

      <br />
      {children}
    </FieldValue>
  );
};

export const PersonValue = Person;
